import React from "react";
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { UnstyledTextAreaField, UnstiledField } from '../common/Inputs';
import { Panel, Button, Alert } from 'react-bootstrap';
import {
    getSettings as getSettingsAction,
    updateSettings as updateSettingsAction,
    clearUpdateSettings as clearUpdateSettingsAction
} from "../../actions/settings";
import * as fetchingState from '../../constants/fetchingState';

import { tablesSettings } from '../../constants/settingTypes';
import * as permissions from '../../constants/permissions';

const validate = ({ RowsPerPage }) => {

    const errors = {};
    if (!RowsPerPage)
        errors.RowsPerPage = "*Поле не может быть пустым";
    else if (RowsPerPage < 1)
        errors.RowsPerPage = "*Значение не может быть меньше 1";
    
    return errors;
}

let TablesSettings = class extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._resetForm = this._resetForm.bind(this);
        this._load = this._load.bind(this);
    }

    _onSubmit(values) {
        this.props.updateSettingsAction(tablesSettings, values);
    }

    _resetForm() {
        this.props.clearUpdateSettingsAction(tablesSettings);
    }

    _load() {
        this.props.clearUpdateSettingsAction(tablesSettings);
        this.props.getSettingsAction(tablesSettings);
    }

    componentDidMount() {
        this.props.getSettingsAction(tablesSettings);
    }

    render() {
        const { handleSubmit, fetching, updateFetching, crudError } = this.props;
        const formVisible = fetching === fetchingState.FETCHED && updateFetching === fetchingState.INITIAL;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (
            <Panel>
                <Panel.Heading>Настройки количества строк на странице</Panel.Heading>
                <Panel.Body>
                    {formVisible && <form className='form-horizontal'>
                        <Field disabled={isReadOnly} name='RowsPerPage' component={UnstiledField} label='Количество записей на страницу' style={{}} type='number' min={1}  />
                        <div style={{ margin: '5px', marginTop: '15px', float: 'right' }}>
                            <Button disabled={isReadOnly} bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                        </div>
                    </form>}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                    {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                    {updateFetching === fetchingState.FETCHING && <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED && <div>
                        <Alert bsStyle='success'>Настройки успешно обновлены</Alert>
                        <Button bsStyle="primary" onClick={this._resetForm}>Закрыть</Button>
                    </div>}
                    {updateFetching === fetchingState.FAILED && <div>
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                        <Button onClick={this._load}>Закрыть</Button>
                    </div>}
                </Panel.Body>
            </Panel>);
    }
}

TablesSettings = reduxForm({
    form: 'TablesSettingsSettingsEdit',
    enableReinitialize: true,
    validate
})(TablesSettings);

TablesSettings = connect(state => {
    const { data, fetching, updateFetching } = state.application.get('settings')[tablesSettings];
    return { initialValues: data, fetching, updateFetching }
}, {
    getSettingsAction,
    updateSettingsAction,
    clearUpdateSettingsAction
})(TablesSettings);

export default TablesSettings;


// WEBPACK FOOTER //
// ./src/components/settings/TablesSettings.jsx